export default __webpack_public_path__ + "static/media/ny-cityguide-07.846ed90c.jpg";